import { defaultCompare } from "logic/DefaultCompare";
import { ALPHABETICAL_SORT } from "./SliceFilters";
import useFetchSlices from "./useFetchSlices";
const compareNullSlices = (left, right) => {
  if (left.value === null && right.value !== null) {
    return -1;
  }
  if (left.value !== null && right.value === null) {
    return 1;
  }
  return 0;
};
const compareNullableValues = (left, right) => {
  if (left == null && right == null) {
    return 0;
  }
  if (left == null) {
    return 1;
  }
  if (right == null) {
    return -1;
  }
  if (typeof left === "number" && typeof right === "number") {
    return left - right;
  }
  return defaultCompare(String(left), String(right));
};
const sortSlices = (items, sortMode, sortDirection, getSliceLabel2) => [...items].sort((left, right) => {
  var _a, _b;
  const nullSliceComparison = compareNullSlices(left, right);
  if (nullSliceComparison !== 0) {
    return nullSliceComparison;
  }
  let comparison = 0;
  if (sortMode === ALPHABETICAL_SORT) {
    comparison = defaultCompare(getSliceLabel2(left), getSliceLabel2(right));
  } else {
    comparison = compareNullableValues((_a = left.meta) == null ? void 0 : _a[sortMode], (_b = right.meta) == null ? void 0 : _b[sortMode]);
  }
  if (comparison !== 0) {
    return sortDirection === "asc" ? comparison : -comparison;
  }
  return defaultCompare(getSliceLabel2(left), getSliceLabel2(right));
});
const getSliceLabel = (slice) => {
  var _a;
  return (_a = slice.title) != null ? _a : String(slice.value);
};
const matchesQuery = (slice, query) => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) {
    return true;
  }
  return getSliceLabel(slice).toLowerCase().includes(normalizedQuery);
};
const isSelectedSlice = (slice, activeSlice) => activeSlice !== void 0 && String(slice.value) === String(activeSlice);
const addMissingSelectedSlice = (slices, activeSlice) => {
  if (activeSlice === void 0) {
    return slices;
  }
  const selectedSliceExists = slices.some((slice) => isSelectedSlice(slice, activeSlice));
  if (selectedSliceExists) {
    return slices;
  }
  return [...slices, { value: activeSlice, count: 0 }];
};
const useSlices = ({
  fetchSlices,
  activeSlice,
  searchQuery,
  sortMode,
  sortDirection,
  sliceRenderers = void 0
}) => {
  const { slices, isLoading, refetchSlices } = useFetchSlices(fetchSlices, sliceRenderers);
  const slicesWithSelected = addMissingSelectedSlice(slices, activeSlice);
  const filteredSlices = slicesWithSelected.filter((slice) => matchesQuery(slice, searchQuery));
  const nonEmptySlices = filteredSlices.filter((slice) => slice.count > 0);
  const emptySlices = filteredSlices.filter((slice) => slice.count === 0);
  return {
    isLoading,
    refetchSlices,
    hasEmptySlices: emptySlices.length > 0,
    emptySliceCount: emptySlices.length,
    visibleNonEmptySlices: sortSlices(nonEmptySlices, sortMode, sortDirection, getSliceLabel),
    visibleEmptySlices: sortSlices(emptySlices, sortMode, sortDirection, getSliceLabel)
  };
};
export default useSlices;
